import { createFileRoute } from '@tanstack/react-router'
import { requireAccess } from '../../../app/guards'
import { PURCHASING_ACCESS } from '../../../features/purchasing/access'
import { NewSupplierRefundPage } from '../../../features/purchasing/refund-pages'
import { newSupplierRefundSearchSchema } from '../../../features/purchasing/search'
import { treasuryOptionsQueryOptions } from '../../../features/sales/queries'

export const Route = createFileRoute('/_app/supplier-refunds/new')({
  staticData: { crumb: 'supplierRefundNew' },
  validateSearch: newSupplierRefundSearchSchema,
  beforeLoad: ({ context }) => requireAccess(context.session, PURCHASING_ACCESS.supplierRefund),
  loader: ({ context }) => {
    // Warm the cash/bank picker; the form does not wait for it.
    void context.queryClient.prefetchQuery(treasuryOptionsQueryOptions)
  },
  component: NewSupplierRefundPage,
})
